module.exports = __webpack_public_path__ + "static/media/ico1-request.d20f6c6a.svg";